import React, { FC, useEffect, useRef, useState } from 'react'
import { IProduct } from '@shared/Types'
import { Box, Collapse, Typography } from '@mui/material'
import { TextEditorPreview } from '@lib/Component/TextEditor'

interface IProps {
  product?: IProduct
}

const minHeight = 200

const UIPlayerDescription: FC<IProps> = (props) => {
  const [expanded, setExpanded] = useState(false)
  const [showToggle, setShowToggle] = useState(false)
  const contentRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (contentRef.current) {
      const check = contentRef.current.scrollHeight > minHeight
      setShowToggle(check)
      setExpanded(!check)
    }
  }, [props.product?.Description])

  return (
    <Box sx={{ background: '#fafafa' }}>
      <Collapse in={expanded} collapsedSize={showToggle ? minHeight : undefined}>
        <Box ref={contentRef} sx={{ position: 'relative', pb: showToggle ? '36px' : 0 }}>
          <TextEditorPreview>{props.product?.Description ?? ''}</TextEditorPreview>
        </Box>
      </Collapse>
      {showToggle && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            backgroundImage: 'linear-gradient(transparent, #fafafa)',
            height: '36px',
            marginTop: '-36px',
            position: 'relative',
            alignItems: 'center',
            zIndex: 10
          }}
        >
          <Typography
            variant='caption'
            component='span'
            onClick={() => setExpanded(!expanded)}
            sx={{ fontWeight: 700, color: '#1976d2', '&:hover': { textDecoration: 'underline' }, cursor: 'pointer' }}
          >
            {expanded ? 'Show less' : 'Show more'}
          </Typography>
        </Box>
      )}
    </Box>
  )
}

export default UIPlayerDescription
